import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text, Flex, Box } from "sprout-ui-primitives";
import Avatar from "@sprout/client-components/dist/Avatar";
import Divider from "sprout-ui-dom/dist/Divider";
import tinytime from "tinytime";
import { Link } from "react-router-dom";
const time = tinytime("Created {h}:{mm}{a} · {MM} {Do}, {YYYY}");
const PostPageToolbarMenuCreatedAt = (props)=>{
    const { createdAt , owner  } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                bg: "white.12",
                m: "8px 16px 16px"
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                px: 3,
                alignItems: "center",
                as: Link,
                to: `/${owner.username}`,
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        mr: "8px",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            user: owner,
                            size: 32
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "time",
                        fontSize: 1,
                        color: "white.70",
                        children: time.render(new Date(createdAt))
                    })
                ]
            })
        ]
    });
};
export default PostPageToolbarMenuCreatedAt;
